import Layout from '@layout/Index'

export const groupBatch = [
  {
    path: '/group-batch',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'customer-table',
        component: () => import(/* webpackChunkName: "group-customer-table" */ './pages/GroupBatchCustomerTable.vue'),
        meta: {
          title: '群组控制',
        },
      },
      {
        path: 'create/:tenant_customerid',
        component: () => import(/* webpackChunkName: "group-batch-form" */ './pages/GroupBatchForm.vue'),
        meta: {
          title: '创建群组控制',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "group-batch-form" */ './pages/GroupBatchForm.vue'),
        meta: {
          title: '修改群组控制',
        },
      },
      {
        path: 'log-table/:id',
        component: () => import(/* webpackChunkName: "group-batch-log-table" */ './pages/GroupBatchLogTable.vue'),
        meta: {
          title: '群组控制修改日志'
        }
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "group-batch-detail" */ './pages/GroupBatchDetail.vue'),
        meta: {
          title: '群组群组控制',
        },
      },
      {
        path: 'table/:tenant_customerid',
        component: () => import(/* webpackChunkName: "group-batch-table" */ './pages/GroupBatchTable.vue'),
        meta: {
          title: '群组控制列表',
        },
      },
      {
        path: 'batch-upload/:id',
        component: () => import(/* webpackChunkName: "group-batch-batch-upload" */ './pages/GroupBatchUpload.vue'),
        meta: {
          title: '上传群组控制目标数',
        },
      },
      {
        path: 'batch-upload-table/:customerid',
        component: () => import(/* webpackChunkName: "group-batch-batch-upload-table" */ './pages/GroupBatchUploadTable.vue'),
        meta: {
          title: '批量上传群组控制目标数',
        },
      },
      {
        path: 'target-table/:id',
        component: () => import(/* webpackChunkName: "group-batch-table" */ './pages/GroupBatchTargetTable.vue'),
        meta: {
          title: '群组控制目标数',
        },
      },
      {
        path: 'market-upload-table/:customerid',
        component: () => import(/* webpackChunkName: "group-batch-market-upload-table" */ './pages/GroupBatchMarketUploadTable.vue'),
        meta: {
          title: '上传客户群组门店关系',
        },
      },
      {
        path: 'market-upload-table/:customerid/project/:projectid',
        component: () => import(/* webpackChunkName: "group-batch-market-upload-table" */ './pages/GroupBatchMarketUploadTable.vue'),
        meta: {
          title: '上传项目群组门店关系',
        },
      },
      {
        path: 'market-table/:customerid',
        component: () => import(/* webpackChunkName: "group-batch-market-table" */ './pages/GroupBatchMarketTable.vue'),
        meta: {
          title: '客户群组门店关系列表',
        },
      },
      {
        path: 'market-table/:customerid/project/:projectid',
        component: () => import(/* webpackChunkName: "group-batch-market-table" */ './pages/GroupBatchMarketTable.vue'),
        meta: {
          title: '项目群组门店关系列表',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/group-batch/group-batch.route.js